import React from 'react';

const MapActiveIcon = () => {
	return (
		<svg
			fill='none'
			height='24'
			viewBox='0 0 24 24'
			width='24'
		>
			<path
				d='M12.2063 21.0001C13.8523 20.9602 15.4562 20.471 16.8442 19.5853C18.2323 18.6996 19.3517 17.4511 20.0813 15.9751L14.9906 12.8438C14.903 12.7875 14.8035 12.7522 14.7 12.7407L12.5531 12.4501C12.393 12.4271 12.2297 12.4578 12.0889 12.5376C11.9481 12.6173 11.8377 12.7415 11.775 12.8907L10.4906 15.7688C10.4303 15.9027 10.4105 16.0513 10.4338 16.1963C10.4572 16.3413 10.5226 16.4763 10.6219 16.5844L12.3844 18.4876C12.4641 18.5751 12.5224 18.6799 12.555 18.7937C12.5875 18.9076 12.5933 19.0274 12.5719 19.1438L12.2063 21.0001Z'
				fill='currentColor'
			/>
			<path
				d='M6.09379 5.21252L5.25004 7.20002C5.17655 7.37646 5.17319 7.57431 5.24066 7.75314L6.31879 10.6219C6.36092 10.7415 6.43305 10.8482 6.52825 10.9319C6.62346 11.0156 6.73856 11.0735 6.86254 11.1L7.36879 11.2031L8.14692 9.35627C8.2053 9.22049 8.30204 9.1047 8.42527 9.02311C8.5485 8.94151 8.69287 8.89764 8.84067 8.89689H10.8469C10.9713 8.89355 11.0932 8.86147 11.2032 8.80314L12.3563 8.16564C12.4074 8.13749 12.4547 8.10283 12.4969 8.06252L15.0188 5.78439C15.1422 5.66961 15.2239 5.51703 15.2511 5.3507C15.2782 5.18436 15.2493 5.01371 15.1688 4.86564L14.2969 3.29064C13.5465 3.09779 12.7748 3.00015 12 3.00002C9.82794 2.99584 7.72855 3.78228 6.09379 5.21252Z'
				fill='currentColor'
			/>
			<path
				d='M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z'
				stroke='currentColor'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M20.0813 15.9751L14.9906 12.8438C14.903 12.7875 14.8035 12.7522 14.7 12.7407L12.5531 12.4501C12.393 12.4271 12.2297 12.4578 12.0889 12.5376C11.9481 12.6173 11.8377 12.7415 11.775 12.8907L10.4906 15.7688C10.4303 15.9027 10.4105 16.0513 10.4338 16.1963C10.4572 16.3413 10.5226 16.4763 10.6219 16.5844L12.3844 18.4876C12.4641 18.5751 12.5224 18.6799 12.555 18.7937C12.5875 18.9076 12.5933 19.0274 12.5719 19.1438L12.2063 21.0001'
				stroke='currentColor'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M6.09379 5.21252L5.25004 7.20002C5.17655 7.37647 5.17319 7.57432 5.24066 7.75315L6.31879 10.6219C6.36092 10.7415 6.43305 10.8482 6.52825 10.9319C6.62346 11.0157 6.73856 11.0735 6.86254 11.1L8.86879 11.5313C8.98014 11.5538 9.08472 11.602 9.17422 11.6719C9.26372 11.7419 9.33569 11.8318 9.38441 11.9344L9.74066 12.675C9.80396 12.8002 9.90032 12.9058 10.0193 12.9801C10.1383 13.0545 10.2754 13.0949 10.4157 13.0969H11.6813'
				stroke='currentColor'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M14.2968 3.29065L15.1687 4.86565C15.2492 5.01372 15.2781 5.18437 15.2509 5.35071C15.2238 5.51704 15.1421 5.66962 15.0187 5.7844L12.4968 8.06253C12.4546 8.10284 12.4073 8.1375 12.3562 8.16565L11.203 8.80315C11.0931 8.86147 10.9712 8.89356 10.8468 8.8969H8.84053C8.69273 8.89765 8.54837 8.94152 8.42514 9.02311C8.30191 9.10471 8.20517 9.2205 8.14678 9.35628L7.36865 11.2032'
				stroke='currentColor'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
};

export default MapActiveIcon;
